// extracted by mini-css-extract-plugin
module.exports = {"container":"DesktopHeader_container__1bE4A","desktopLogo":"DesktopHeader_desktopLogo__1Ym7A"};